export default __webpack_public_path__ + "static/media/lottery-hover.e595070a.webp";